export default __webpack_public_path__ + "static/Julie-c2582dfce81b151a75605c0d1abd256c.png";